import { isNumber } from "lodash";

export default function hasMistakes(questionsCorrect?: number, questionsTotal?: number): boolean {
  if (!isNumber(questionsCorrect) || !isNumber(questionsTotal)) {
    return false;
  };

  return questionsCorrect < questionsTotal;
}
